import i18next from 'i18next'
import React from 'react'
import { ImageBase } from '../../../../utils/image'
import { ParsedPhoneNumber } from '../../../../utils/phoneNumber'
import { Link } from '../../cmsPageState'
import { GenericPageHeader } from '../../../sharedLayout/pageheader'

type LocationPageHeaderProps = {
  title: string
  intro: string
  link?: Link
  image?: ImageBase
  breadcrumbs: { url: string; title: string }[]
  phoneNumber?: Array<ParsedPhoneNumber & { description: string }>
}

export const LocationPageHeader = (props: LocationPageHeaderProps) => (
  <GenericPageHeader
    kind="locationDetail"
    breadcrumbs={props.breadcrumbs}
    title={props.title}
    intro={props.intro}
    link={props.link}
    image={props.image}
    extraJSXBelowTitle={
      props.phoneNumber && (
        props.phoneNumber.map(x =>
          <p key={x.formatted+x.uri} className="pageheader__phone block--phone phone--big">
            <span className="sr-text">{`${i18next.t('common:phoneNumber')} ${x.description}`}</span>
            <a
              href={x.uri}
              className="block__link link--inverted"
              title={i18next.t('common:callOn', { location: props.title })}
            >
              {x.formatted}
            </a>
          </p>
        )
      )
    }
  />
)
